module.exports = __webpack_public_path__ + "img/logo-blue.12a87a3b.png";